<script setup lang="ts">
  import { useScrollDirection } from "@src/hooks";
  import {
    MainPageActionCheckPairs,
    MainPageActionZoning,
    MainPageActionCheckSales,
    MainPageActionFitting,
    MainPageActionOrders,
    MainPageActionAlarming,
    MainPageActionMoneymap,
  } from "./Actions";

  const vertical_scroll = useScrollDirection("vertical");
</script>

<template>
  <div
    class="main-page-menu-shopfloor"
    data-testid="main-page-menu-shopfloor"
    @touchstart="vertical_scroll.start"
    @touchmove="vertical_scroll.move"
    @touchend="vertical_scroll.end"
  >
    <MainPageActionCheckPairs />
    <MainPageActionZoning />
    <MainPageActionCheckSales />
    <MainPageActionFitting />
    <MainPageActionAlarming disable-write-action />
    <MainPageActionOrders />
    <MainPageActionMoneymap />
  </div>
</template>

<style scoped>
  .main-page-menu-shopfloor {
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    padding: 16px 16px 96px;
  }
</style>
